import { useState } from "react";
import { Copy, Check } from "@phosphor-icons/react";

export default function CopyButton({ text, label = "Copy", className = "", testId = "copy-to-clipboard-button" }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      const ta = document.createElement("textarea");
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      data-testid={testId}
      className={`inline-flex items-center gap-2 border px-3.5 py-2 text-xs font-bold uppercase tracking-[0.12em] transition-all duration-150 active:scale-[0.97] ${
        copied
          ? "border-green-600 bg-green-600 text-white"
          : "border-border bg-card hover:-translate-y-0.5 hover:border-primary hover:text-primary"
      } ${className}`}
    >
      {copied ? <Check size={15} weight="bold" /> : <Copy size={15} weight="bold" />}
      {copied ? "Copied!" : label}
    </button>
  );
}
